export type PaginationItem = {
  id: number;
  name: string;
  note?: string;
};

export const PAGE_SIZE_OPTIONS = [5, 8, 12, 20];

export function makePaginationData(
  count = 53,
  note = 'Placeholder row for pagination demo.'
): PaginationItem[] {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `Record #${i + 1}`,
    note,
  }));
}

export const DEFAULT_PAGINATION_DATA = makePaginationData(53);
